import { Box } from "@mui/system";
import { ExchangeType, FoodLimitedAccessFragment, FullFoodGroupWithFoodsFragment } from "../../../../types";
import { ExchangeBox } from "./ExchangeBox";
import { FoodGroupHeader } from "./FoodGroupHeader";

type GroupedFoodMap = {
  [key in ExchangeType]: FoodLimitedAccessFragment[];
};

const groupFoodsByExchange = (foods: readonly FoodLimitedAccessFragment[]): GroupedFoodMap => {
  let groups: GroupedFoodMap = {
    starch: [],
    fat: [],
    protein: [],
    dairy: [],
    fruit: [],
    vegetable: [],
    "%future added value": [],
  };

  foods.forEach(f => {
    const firstExchangeType = f.exchangeTypes && f.exchangeTypes[0];
    if (!!firstExchangeType) {
      groups[firstExchangeType] = [...groups[firstExchangeType], f];
    }
  });
  return groups;
};

export const getFoodGroupsComponentsArray = (foodGroups: readonly FullFoodGroupWithFoodsFragment[], type: "promoted" | "avoided") =>
  foodGroups.flatMap((foodGroup, foodGroupIdx) => {
    // get all parts of each food group into an array
    const { id, name, foods } = foodGroup;
    const renderExchangeBox = (exchangeType: ExchangeType, lastChild: boolean) => (
      <ExchangeBox key={`${exchangeType}-${id}`} foods={exchangeGroupedFoods[exchangeType]} name={exchangeType} lastChild={lastChild} />
    );
    const exchangeGroupedFoods = groupFoodsByExchange(foods);
    const exchangeTypes = Object.keys(exchangeGroupedFoods).filter(et => et !== "%future added value") as ExchangeType[];
    return exchangeTypes.map((exchangeType, idx) =>
      idx === 0 ? (
        // group header and the first exchange box together
        <Box sx={{ ":not(:first-child)": { pt: type === "promoted" && foodGroupIdx === 0 ? 7 : 0 } }}>
          <FoodGroupHeader key={id} foodGroupName={name} promotedOrAvoided={type} />
          {renderExchangeBox(exchangeType, exchangeTypes.length === 1)}
        </Box>
      ) : (
        renderExchangeBox(exchangeType, idx === exchangeTypes.length - 1)
      )
    );
  });
